import { routes } from '@routes';

import { messageIdConcat } from '@utils/message-id-concat';
import { link, RouteLink } from '@utils/link';

import { Message } from '@atoms';

export type BaseNavLink = {
  message: Message;
  activeMatch?: RegExp;
  external?: boolean;
};

export type BasicNavLink = BaseNavLink & {
  link: RouteLink;
};

export type NestedNavLink = BaseNavLink & {
  subLinks: BasicNavLink[];
};

export type NavLink = BasicNavLink | NestedNavLink;

const m = messageIdConcat('nav.links');

const factoryCmsLink = (path: string, activeMatch?: RegExp) => ({
  link: link(routes.page, { path }),
  activeMatch: activeMatch || new RegExp(`^/${path}`),
});

export const navLinks: NavLink[] = [
  {
    message: { id: m('sell') },
    ...factoryCmsLink('pro-prodavajici'),
  },
  {
    message: { id: m('buy') },
    ...factoryCmsLink('pro-kupujici'),
  },
  {
    message: { id: m('estimate_price') },
    link: link(routes.estimateLandingPage),
    activeMatch: /^\/odhad-ceny/,
  },
  {
    message: { id: m('atlas') },
    ...factoryCmsLink(
      'cenova-mapa',
      /^\/cenova-mapa|^\/prodane|^\/atlas-cen-interni/,
    ),
  },
  {
    message: { id: m('blog') },
    link: link(routes.blogHomepage),
    activeMatch: /^\/blog/,
  },
];
